import { render, staticRenderFns } from "./noticeDetailNew.vue?vue&type=template&id=057fe57c&scoped=true"
import script from "./noticeDetailNew.vue?vue&type=script&lang=js"
export * from "./noticeDetailNew.vue?vue&type=script&lang=js"
import style0 from "./noticeDetailNew.vue?vue&type=style&index=0&id=057fe57c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057fe57c",
  null
  
)

export default component.exports